import {wechatguid, wechatstate} from "./api";
import {getTimestamp, sleep} from "./common/utils";
import PhoneLogin from "./libs/PhoneLogin";

export * from "./api";

export const config = {
	apiDomain: "http://app.xunjiepdf.com/",
	productInfo: "",
	code: 10000,
	productId: 0,
	productName: "",
};

export function setConfig(conf) {
	Object.assign(config, conf);
	if (config.apiDomain.endsWith("/")) config.apiDomain = config.apiDomain.slice(0, -1);
	getTimestamp();
}

let thirdLoginStop;
let thirdLoginCache;
export function thirdLogin(limit) {
	if (limit == null) limit = 200;
	if (thirdLoginCache && thirdLoginCache.time + 60e3 > Date.now()) {
		console.log(thirdLoginCache, "使用缓存");
		return Promise.resolve(thirdLoginCache);
	}
	return wechatguid().then((logintag) => {
		let waitpms;
		function check(rest) {
			if (!rest) return Promise.reject("retry times limit:" + limit);
			if (!waitpms) return Promise.reject("stop wechatstate:" + logintag);
			return sleep(1e3)
				.then(() => wechatstate(logintag, true))
				.then(
					(ret) => {
						thirdLoginCache = null;
						return ret;
					},
					() => check(rest - 1)
				);
		}
		function wait() {
			if (waitpms) return waitpms;
			waitpms = true;
			waitpms = check(limit);
			waitpms.finally(() => (waitpms = null));
			return waitpms;
		}
		function stop() {
			waitpms = null;
		}
		// 停止上一个登录检查
		if (thirdLoginStop) thirdLoginStop();
		thirdLoginStop = stop;
		let time = Date.now();
		thirdLoginCache = {time, logintag, wait, stop};
		return thirdLoginCache;
	});
}

export {PhoneLogin};
